/**
 * Help §5.10 — Finishing & launching (`document/LaunchedStageView.tsx`,
 * `project/ProjectDetailView.tsx`).
 */
import { helpSectionMeta } from '../help-sections.js';
import { Btn, Bullets, Callout, HelpSectionCard, Li, P, Screen, Shot } from '../HelpPrimitives.js';

export function Finish(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('finish')}>
      <P>
        Once every document card is approved, click <Btn>Confirm &amp; Move to Final</Btn>. The
        project moves to <Screen>Launched</Screen>, where you get:
      </P>
      <Bullets>
        <Li>
          a <Btn>Package Ready for Delivery</Btn> banner with a <Btn>Send Final Package</Btn>{' '}
          button;
        </Li>
        <Li>
          a read-only mirror of all six documents — <Btn>Preview</Btn> and <Btn>Download</Btn> only,
          no further editing;
        </Li>
        <Li>
          a <Btn>Download All</Btn> button to export everything at once.
        </Li>
      </Bullets>
      <Shot
        slug="launched"
        caption="The Launched stage — the Package Ready for Delivery banner above the read-only documents."
      />
      <Callout tone="change" title="What Send Final Package does">
        <P>
          It doesn’t just mark the project as done — it actually emails the client a package with
          links to the finished documents. Make sure every document is in the state you want before
          you send it.
        </P>
      </Callout>
    </HelpSectionCard>
  );
}
